export const QUERY_PARAMS = {
  REQUEST_ID: 'request-id',
  BANK_ID: 'bank-id',
  CALLBACK_URL: 'callback-url',
  CODE: 'code',
  SCOPE: 'scope',
  STATE: 'state',
};
